import { feedUpdateFilterCriteria } from "../../../actions/feed-actions"
import {
    autocompleteTopicsRequest,
    autocompleteSourcesRequest
} from "../../../actions/autocomplete-actions"

import buildItemConnector from "../../common/build-item-connector"
import FeedKnowledgeListFilterForm from "./FeedKnowledgeListFilterForm"

export default buildItemConnector(
    "feed",
    true,
    feedUpdateFilterCriteria,
    null,
    {
        onTopicsSearch: autocompleteTopicsRequest,
        onSourcesSearch: autocompleteSourcesRequest
    }
)(FeedKnowledgeListFilterForm)
